"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DependencyError_1 = require("../Error/DependencyError");
class DependencyContainer {
    constructor() {
        this.injections = new Map();
        this.services = new Map();
    }
    /**
     * The "injectable" decorators
     */
    registerService(serviceClass, injectableOptions) {
        if (injectableOptions === undefined) {
            injectableOptions = {};
        }
        if ('key' in injectableOptions === false || injectableOptions.key === undefined) {
            injectableOptions.key = serviceClass;
        }
        if ('args' in injectableOptions === false || injectableOptions.args === undefined) {
            injectableOptions.args = [];
        }
        if (this.services.has(injectableOptions.key)) {
            throw new Error(`There is already a service registered with key: ${String(injectableOptions.key)}`);
        }
        this.services.set(injectableOptions.key, { $targetConstructor: serviceClass, args: injectableOptions.args, isConstructing: false });
    }
    hasServiceWithConstructor(target) {
        return [...this.services.values()].some(service => service.$targetConstructor === target);
    }
    getServicesWithConstructor(target) {
        return [...this.services.values()].filter(service => service.$targetConstructor === target);
    }
    /**
     * The "inject" decorators
     */
    registerInjection(target, injection) {
        let injections = this.injections.get(target);
        if (injections === undefined) {
            injections = [];
            this.injections.set(target, injections);
        }
        injections.push(injection);
    }
    applyInjections(target, originalArguments) {
        const injections = this.injections.get(target);
        if (injections === undefined || injections.length === 0) {
            return originalArguments;
        }
        injections
            // make sure the injections are in the correct order
            .sort((firstInjection, secondInjection) => firstInjection.parameterIndex - secondInjection.parameterIndex)
            // mix injections into original arguments
            .forEach((injection) => {
            let registered = this.services.get(injection.key);
            if (registered === undefined && typeof injection.key !== 'string') {
                // try to find the injectable on the parent constructor. This can happen if you use @injectable and @component on the same class.
                registered = this.services.get(Object.getPrototypeOf(injection.key));
            }
            // if there is still no registered class found, that's bad.
            if (registered === undefined) {
                throw new DependencyError_1.default(`There is no injectable service registered for injection parameter "${String(injection.key)}". Make sure to add @injectable to the class you want to inject`);
            }
            if (registered.isConstructing) {
                throw new DependencyError_1.default(`Circular dependency detected on service key: ${String(injection.key)}`);
            }
            if (registered.instance === undefined) {
                /* eslint-disable-next-line new-cap*/
                registered.isConstructing = true;
                registered.instance = new registered.$targetConstructor(...registered.args);
                registered.isConstructing = false;
            }
            originalArguments.splice(injection.parameterIndex, 0, registered.instance);
        });
        return originalArguments;
    }
}
exports.default = DependencyContainer;
//# sourceMappingURL=DependencyContainer.js.map